// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1IV6P","content":"styles_content__3u_hk","selectAll":"styles_selectAll__3ng0Q"};